export const createFileSystem = (fileSystem) => {
    return new FileSystemImpl(fileSystem);
};
class FileSystemImpl {
    fileSystem;
    constructor(fileSystem) {
        this.fileSystem = fileSystem;
    }
    getEntryKey(path) {
        return this.fileSystem.getEntryKey(path);
    }
    getPath(entryKey) {
        return this.fileSystem.getPath(entryKey);
    }
    getPathsByIdsBulk(ids) {
        return this.fileSystem.getPathsByIdsBulk(ids);
    }
    getMetadata(entryKey) {
        return this.fileSystem.getMetadata(entryKey);
    }
    createFile(path) {
        return this.fileSystem.createFile(path);
    }
    readFile(entryKey, buffer, offset) {
        return this.fileSystem.readFile(entryKey, buffer, offset);
    }
    deleteFile(path) {
        return this.fileSystem.deleteFile(path);
    }
    createHardLink(targetPath, linkPath) {
        return this.fileSystem.createHardLink(targetPath, linkPath);
    }
    createDir(path) {
        return this.fileSystem.createDir(path);
    }
    readDir(entryKey) {
        return this.fileSystem.readDir(entryKey);
    }
    readDirPaginated(entryId, limit, cursor) {
        return this.fileSystem.readDirPaginated(entryId, limit, cursor);
    }
    deleteDir(path) {
        return this.fileSystem.deleteDir(path);
    }
    fileExists(path) {
        return this.fileSystem.fileExists(path);
    }
    dirExists(path) {
        return this.fileSystem.dirExists(path);
    }
    move(sourcePath, destinationPath, overwrite) {
        return this.fileSystem.move(sourcePath, destinationPath, overwrite);
    }
    getEntryInfoById(entryId) {
        return this.fileSystem.getEntryInfoById(entryId);
    }
    createDirById(parentId, name) {
        return this.fileSystem.createDirById(parentId, name);
    }
    deleteDirById(dirId) {
        return this.fileSystem.deleteDirById(dirId);
    }
    resolve(entryPath) {
        return this.fileSystem.resolve(entryPath);
    }
}
